import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';

// icons
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";

// api
import { getAuditQuestionFromAlcohol, getAuditScoreFromAlcohol, getEducationProgressWeekFromAlcohol, getRtcqQuestionFromAlcohol, getRtcqStageFromAlcohol } from "../../../../services/apis/alcohol/education";
import { getDrinkRejectionFromAlcohol, getEducationQuestionWeekFromAlcohol, getQuestionHabitFromAlcohol } from "../../../../services/apis/alcohol/question";
import { getPatientSupporterFromAlcohol } from '../../../../services/apis/alcohol/patient';


// components
import { Module11Box144Item, Module11Box149Item, Module12Box102Item, Module12Box103Item, Module12Box92Item, Module1BoxItem, Module2BoxItem, Module3Box23Item, Module3Box34Item, Module4Box40Item, Module4Box43Item, Module5Box127Item, Module5Box51Item, Module5BoxItem, Module7Box61Item, Module7BoxItem, Module8Box66Item, Module8Box67Item, Module9Box72Item } from "./moduleBox/ModuleBoxList";



const moduleBoxList = [
    {
        moduleId: 1,
        component: (patientSex, auditScore) => <Module1BoxItem patientSex={patientSex} auditScore={auditScore} />,
    },
    {
        moduleId: 2,
        component: (rtcqStage) => <Module2BoxItem rtcqStage={rtcqStage} />,
    },
    {
        moduleId: 3,
        questionId: [23],
        component: (answerList) => <Module3Box23Item answerList={answerList} />,
    },
    {
        moduleId: 3,
        questionId: [34],
        component: (answerList) => <Module3Box34Item answerList={answerList} />,
    },
    {
        moduleId: 4,
        questionId: [40, 41],
        component: (answerList) => <Module4Box40Item answerList={answerList} />,
        boxSize: 'lg'
    },
    {
        moduleId: 4,
        questionId: [43, 44],
        component: (answerList) => <Module4Box43Item answerList={answerList} />,
        boxSize: 'md'
    },
    {
        moduleId: 5,
        component: (answerList) => <Module5BoxItem answerList={answerList} />
    },
    {
        moduleId: 5,
        questionId: [52, 51, 53],
        component: (answerList) => <Module5Box51Item answerList={answerList} />
    },
    {
        moduleId: 5,
        questionId: [127],
        component: (answerList) => <Module5Box127Item answerList={answerList} />
    },
    {
        moduleId: 7,
        component: (answerList) => <Module7BoxItem answerList={answerList} />
    },
    {
        moduleId: 7,
        questionId: [61],
        component: (answerList) => <Module7Box61Item answerList={answerList} />,
    },    
    {
        moduleId: 8,
        questionId: [66],
        component: (answerList) => <Module8Box66Item answerList={answerList} />
    },
    {
        moduleId: 8,
        questionId: [67],
        component: (answerList) => <Module8Box67Item answerList={answerList} />
    },
    {
        moduleId: 9,
        questionId: [72],
        component: (answerList) => <Module9Box72Item answerList={answerList} />
    },
    {
        moduleId: 11,
        questionId: [144, 145, 146, 147, 148],
        component: (answerList) => <Module11Box144Item answerList={answerList} />
    },
    {
        moduleId: 11,
        questionId: [149, 150, 151, 152],
        component: (answerList) => <Module11Box149Item answerList={answerList} />
    },
    {
        moduleId: 12,
        questionId: [92],
        component: (answerList) => <Module12Box92Item answerList={answerList} />
    },
    {
        moduleId: 12,
        questionId: [102],
        component: (answerList) => <Module12Box102Item answerList={answerList} />
    },
    {
        moduleId: 12,
        questionId: [103, 104, 105],
        component: (answerList) => <Module12Box103Item answerList={answerList} />
    }
];


function AccordianItem({title, list, patientName, hbtScore}) {
    const [open, setOpen] = useState(false);

    return (
        <div key={title} className="education_box2_accordian">
            <button
                className="education_accordian_button"
                onClick={()=>setOpen(!open)}
            >
                <span>{title}</span>
                {open ? <IoIosArrowUp/> : <IoIosArrowDown />}
            </button>
            {open && <div className="education_accordian_content">
                {
                    list.map((e, idx) => (
                        <div key={idx} className="education_accordian_content_item">
                            <span>{e.questionText.replace(/{{name}}/g, patientName).replace(/<br>/g, "\n").replace(/{{hbt_socre}}/g, hbtScore)}</span>
                            <div className="education_accordian_content_divider" />
                            <span>{e.answer.join(', ')}</span>
                        </div>
                    ))
                }
            </div>}
        </div>
    )
}

function AlcoholEducation({patientData}) {
    const { pid } = useParams();
    const [patientName, setPatientName] = useState("");

    // 선택한 세션의 진행도
    const [curProgressRate, setCurProgressRate] = useState(0);
    // 진행 중인 세션
    const [onGoingSession, setOnGoingSession] = useState(0);
    // 현재 선택한 세션
    const [selectedSession, setSelectedSession] = useState(0);
    
    // 진행 데이터
    const [progressData, setProgressData] = useState([]);
    
    // AUDIT-K 점수 데이터
    const [auditScoreData, setAuditScoreData] = useState(-1);
    // AUDIT-K 질문 데이터
    const [auditQuestionData, setAuditQuestionData] = useState([]);
    // RTCQ 단계 데이터
    const [rtcqStageData, setRtcqStageData] = useState("");
    // RTCQ 질문 데이터
    const [rtcqQuestionData, setRtcqQuestionData] = useState([]);

    // 질문 및 답변 데이터
    const [questionData, setQuestionData] = useState(null); 

    // 음주 습관 변화도 데이터
    const [questionHabitData, setQuestionHabitData] = useState([]);

    // 환자 서포터 데이터
    const [patientSupporterData, setPatientSupporterData] = useState([]);

    // 음주 거절 효능감 그래프 데이터
    const [drinkRejectionData, setDrinkRejectionData] = useState(null);


    // 진행 데이터 API 조회
    async function getProgressFromAPI() {
        try {
            const request = { pid, weekNum: selectedSession };
            const res = await getEducationProgressWeekFromAlcohol(request);
           
            if(parseInt(res.status/200,10)===1){
                if(res.data.progressWeeks){
                    setProgressData(res.data.progressWeeks);
                }
                try{
                    if(res.data.progressWeeks.length>0){                        
                        const lastFinishSession = res.data.progressWeeks.findLastIndex(e=>e.status.statusName==="완료") + 1;
                        // 모든 주차 학습 완료
                        if(lastFinishSession===8){
                            setOnGoingSession(8);
                            setSelectedSession(8);
                            return;
                        }
                        const newOngoingSession = res.data.progressWeeks.findLastIndex(e=>e.status.statusName==="진행중") + 1;
                        setOnGoingSession(newOngoingSession===0 ? 0 : newOngoingSession);
                        setSelectedSession(newOngoingSession===0 ? 1 : newOngoingSession);
                    }
                }catch(err){
                    console.error(err);
                }
                
            }else{
                throw new Error();
            }
        }catch(err){
            console.error(err);
        }
    }

    // AUDIT-K 점수 데이터 API 조회
    async function getAuditScoreFromAPI() {
        try{
            const request = { pid };
            const res = await getAuditScoreFromAlcohol(request);
            if(parseInt(res.status/200,10)===1){
                setAuditScoreData(res.data);
            }else{
                setAuditScoreData(-1);
            }
        }catch(err){
            console.error(err);
            setAuditScoreData(-1);
        }
    }

    // AUDIT-K 질문 데이터 API 조회
    async function getAuditQuestionFromAPI() {
        try{
            const request = { pid };
            const res = await getAuditQuestionFromAlcohol(request);
            
            if(parseInt(res.status/200,10)===1) {
                const newAuditQuestionData = [];

                const originalData = res.data;
                originalData.forEach((e)=>{
                    if(e.check){
                        newAuditQuestionData.push({
                            questionText: e.questionText,
                            answer: e.answers.filter(el=>el.itemCheck).map(el=>el.itemName)
                        })
                    }                    
                })
                setAuditQuestionData(newAuditQuestionData);
            }else{
                setAuditQuestionData([]);
            }
        }catch(err){
            console.error(err);
            setAuditQuestionData([]);
        }
    }
    
    // RTCQ 단계 데이터 API 조회
    async function getRtcqStageFromAPI() {
        try{
            const request = { pid };
            const res = await getRtcqStageFromAlcohol(request);
            if(parseInt(res.status/200,10)===1){
                setRtcqStageData(res.data.stageName || "");
            }else{
                setRtcqStageData("");
            }
        }catch(err){
            console.error(err);
            setRtcqStageData("");
        }
    }

    // RTCQ 질문 데이터 API 조회
    async function getRtcqQuestionFromAPI() {
        try {
            const request = { pid };
            const res = await getRtcqQuestionFromAlcohol(request);
            
            if(parseInt(res.status/200,10)===1){
                if(res.data.answers && res.data.answers.length > 0){
                    const originalData = res.data.answers;

                    const newRtcqQuestionData = [];
                    originalData.forEach((e)=>{
                        newRtcqQuestionData.push({
                            questionText: e.itemName,
                            answer: [e.itemValue]
                        })
                    })
                    setRtcqQuestionData(newRtcqQuestionData);
                }else{
                    setRtcqQuestionData([]);
                }                
            }else{
                setRtcqQuestionData([]);
            }
        }catch(err){
            console.error(err);
            setRtcqQuestionData([]);
        }
    }

    // 설문 데이터 API 조회
    async function getQuestionFromAPI() {
        try{
            const request = { pid, weekNum: selectedSession };
            const res = await getEducationQuestionWeekFromAlcohol(request);

            if(parseInt(res.status/200,10)===1){
                const newQuestData = {};
                res.data.forEach(e=>{                    
                    if(e.isAnswer==="Y"){
                        let answerArr = JSON.parse(e.answer);
                        const questionText = e.questionText.replace(/{{wheel:asc,itemValue,itemName:1}}/g,'라이프 밸런스 휠 항목 중 가장 점수가 낮은 항목');
                        
                        if(e.contentType==="txt") {
                            answerArr = answerArr.filter(filterEl=>filterEl.itemCheck).map(mapEl=>mapEl.itemValue);
                        }else if(e.contentType==="popup"){
                            // 라이프 밸런스 휠 데이터의 경우, "itemName(itemValue점)"으로 사용함
                            if(e.questionId===154){
                                answerArr = answerArr.map(mapEl=>`${mapEl.itemName}(${mapEl.itemValue}점)`);
                            // itemCheck: true인 항목이 존재할 경우, 해당 항목의 itemName을 사용함
                            }else if(answerArr.filter(filterEl=>filterEl.itemCheck).length>0){
                                answerArr = answerArr.filter(filterEl=>filterEl.itemCheck).map(mapEl=>mapEl.itemName==="직접입력" ? mapEl.itemValue : mapEl.itemName);
                            }else{
                                answerArr = answerArr.map(mapEl=>mapEl.itemValue);
                            }                         
                        }else{
                            answerArr = answerArr.filter(filterEl=>filterEl.itemCheck).map(mapEl=>mapEl.itemName);
                        }

                        if(!newQuestData[e.moduleId]){
                            newQuestData[e.moduleId] = {
                                [e.groupId] : [
                                    {
                                        groupSubject: e.groupSubject,
                                        questionId: e.questionId,
                                        questionText,
                                        answer: answerArr
                                    }
                                ]
                            }
                        }else if(!(e.groupId in newQuestData[e.moduleId])){
                            newQuestData[e.moduleId] = {
                                ...newQuestData[e.moduleId],
                                [e.groupId] : [
                                    {
                                        groupSubject: e.groupSubject,
                                        questionId: e.questionId,
                                        questionText,
                                        answer: answerArr
                                    }
                                ]
                            }
                        }else{
                            newQuestData[e.moduleId][e.groupId].push({
                                groupSubject: e.groupSubject,
                                questionId: e.questionId,
                                questionText,
                                answer: answerArr
                            })
                        }
                    }                    
                })
                setQuestionData(newQuestData);
            }else{
                throw new Error();
            }
        }catch(err){
            console.error(err);
        }
    }

    // 음주 습관 변화도 API 조회
    async function getQuestionHabitFromAPI() {
        try {
            const res = await getQuestionHabitFromAlcohol({ pid });
            
            if(parseInt(res.status/200,10)===1){
                setQuestionHabitData(res.data);
            }else{
                throw new Error();
            }
        }catch(err){
            console.error(err);
        }
    }

    // 환자 서포터 API 조회
    async function getPatientSupporterFromAPI() {
        try{
            const res = await getPatientSupporterFromAlcohol({ pid });
            if(parseInt(res.status/200,10)===1){
                setPatientSupporterData(res.data);
            }else{
                throw new Error();
            }
        }catch(err){
            console.error(err);
            setPatientSupporterData([]);
        }
    }

    // 음주 거절 효능감 그래프 데이터 API 조회
    async function getDrinkRejectionDataFromAPI() {
        try {
            const res = await getDrinkRejectionFromAlcohol({questionId: 131, pid});
            if(parseInt(res.status/200,10)===1){
                setDrinkRejectionData(res.data);
            }else{
                throw new Error();
            }
        }catch(err){
            console.error(err);
            setDrinkRejectionData(null);
        }
    }

    // 교육 진행도 적용
    function getProgressRating() {
        try {
            const newProgressData = progressData[selectedSession-1].status.progressRate;
            setCurProgressRate(newProgressData);
        }catch(err){
            console.error(err);
        }
    }

    // 음주 습관 변화도 출력
    function printHbtScore(targetWeekNum) {
        if(questionHabitData.length<1) return 0;

        try{
            const target = questionHabitData.filter(e=>e.weekNum===targetWeekNum)[0];

            if(!target) return 0;
            
            return target.score || 0;
        }catch(err){
            console.error(err);
            return 0;
        }        
    }

    // 모듈 박스에 필요한 데이터가 하나라도 존재하면 true(모듈 박스 출력), 데이터가 하나도 없으면 false 반환(모듈 박스 미출력)
    function checkSomeIncludeData(curModuleId, curQuestionId) {
        let questionDataList = [];
        Object.values(questionData[curModuleId]).forEach(e=>{
            questionDataList = questionDataList.concat(e);
        })
        return curQuestionId.some(id=>questionDataList.filter(e=>e.questionId===id).length>0);
    }

    // 모듈박스 데이터 출력 - 입력한 moduleId, questionId에 해당하는 answerList 출력
    function printModuleBoxAnswer(curModuleId, curQuestionId) {
        let questionDataList = [];
        Object.values(questionData[curModuleId]).forEach(e=>{
            questionDataList = questionDataList.concat(e);
        })

        // [M005 서포터] 모듈 박스
        // questionId 34의 answer이 '호흡명상'일 경우 [28, 29]의 데이터를 사용하고, '갈망 파도타기 명상'일 경우 [31, 32]의 데이터를 사용함.
        if(curQuestionId[0]===34 && curQuestionId.length===1) {
            const flag = questionDataList.filter(e=>e.questionId===34)[0].answer;
            let idList = [];
            const newAnswerList = [];
            if(flag==='호흡명상'){
                idList = [28, 29];
            }else{
                idList = [31, 32];
            }
            idList.forEach(id=> {
                newAnswerList.push(questionDataList.filter(e=>e.questionId===id)[0]);
            })
            return newAnswerList;
        }

        const newAnswerList = [];
        curQuestionId.forEach(id=>{
            newAnswerList.push(questionDataList.filter(e=>e.questionId===id)[0])
        })

        return newAnswerList;
    }

    useEffect(()=>{
        getProgressFromAPI();        
        getAuditScoreFromAPI();
        getAuditQuestionFromAPI();
        getRtcqStageFromAPI();
        getRtcqQuestionFromAPI();
        getQuestionHabitFromAPI();
        getPatientSupporterFromAPI();
        getDrinkRejectionDataFromAPI();
    },[])

    useEffect(()=>{
        if(selectedSession){
            getQuestionFromAPI();
        }        
    },[selectedSession])

    useEffect(()=>{
        if(progressData.length>0){
            getProgressRating();
        }        
    },[progressData, selectedSession])

    useEffect(()=>{
        if(patientData.name){
            setPatientName(patientData.name);
        }
    },[patientData])


    return (
        <div className="patientResult__education">
            <div className="education_session">
                {[1,2,3,4,5,6,7,8].map(e=>(
                    <div key={e} className="education_session_item">
                        <button
                            className={`education_session_circle ${e <= onGoingSession ? "bold-border" : ""} ${e===selectedSession ? "selected" : ""}`}
                            onClick={()=>setSelectedSession(e)}
                        >{e}</button>
                        {e<onGoingSession && e!==8 && <div className="education_session_bar" />}
                        {e>=onGoingSession && e!==8 && (
                            <div className="education_session_bar_dot">
                                <div className="dot" />
                                <div className="dot" />
                                <div className="dot" />
                            </div>
                        )}
                    </div>
                ))}
            </div>
            <div className="education_box1">
                <div className="education_progress">
                    <div className="education_progress_label">교육 진행도</div>
                    <div className="education_progress_percentage">{curProgressRate}%</div>
                    <div className="education_progress_bar_wrapper">
                        <div className="education_progress_bar" style={{ width: `${curProgressRate}%`}} />
                    </div>
                </div>
                
                <div className="module_graph_box">
                    {
                       progressData.length>0 && progressData[selectedSession-1].modules.map(moduleItem => (
                            moduleBoxList.filter(e=>e.moduleId===moduleItem.moduleId).map((boxItem, boxItemIdx) => (
                                <div key={`${moduleItem.moduleId}-${boxItemIdx}`}>
                                    {boxItem.moduleId===1 && auditScoreData>=0 && (
                                        <div className="module_graph_box_item_wrapper">
                                            {boxItem.component(patientData.sex, auditScoreData)}
                                        </div>
                                    )}
                                    {boxItem.moduleId===2 && rtcqStageData && (
                                        <div className="module_graph_box_item_wrapper">
                                            {boxItem.component(rtcqStageData)}
                                        </div>
                                    )}
                                    {boxItem.moduleId===5 && !boxItem.questionId && patientSupporterData.length>0 && (
                                        <div className="module_graph_box_item_wrapper">
                                        {boxItem.component(patientSupporterData)}
                                    </div>
                                    )}
                                    {boxItem.moduleId===7 && !boxItem.questionId && drinkRejectionData && (
                                        <div className="module_graph_box_item_wrapper">
                                        {boxItem.component([drinkRejectionData])}
                                    </div>
                                    )}
                                    {questionData && questionData[moduleItem.moduleId] && boxItem.questionId && checkSomeIncludeData(boxItem.moduleId, boxItem.questionId) && (
                                        <div className={`module_graph_box_item_wrapper ${boxItem.boxSize==='md' ? 'md' : ""} ${boxItem.boxSize==='lg' ? "lg" : ""}`}>
                                            {boxItem.component(printModuleBoxAnswer(boxItem.moduleId, boxItem.questionId))}
                                        </div>
                                    )}
                                </div>
                            ))
                        ))
                    }
                </div>
            </div>
            {progressData.length>0 && progressData[selectedSession-1].modules.map((e, moduleIdx)=>(
                <div key={moduleIdx} className="education_box2">
                    <div className="education_box2_header">
                        <div className="education_header_badge">모듈 {e.moduleId}</div>
                        <div className="education_header_title">{e.moduleSubject}</div>
                        <div className="education_header_satisfaction">평균 만족도 : {e.status.avgScore}</div>
                    </div>
                    {
                        questionData && questionData[e.moduleId] && Object.values(questionData[e.moduleId]).map((item, idx) => (
                            <AccordianItem
                                key={idx}
                                title={item[0].groupSubject}
                                list={item}
                                patientName={patientName}
                                hbtScore={printHbtScore(selectedSession)}
                            />
                        ))
                    }
                    {selectedSession===1 && e.moduleId===1 && auditQuestionData.length>0 && <AccordianItem
                        title="알코올 사용장애 선별검사(AUDIT-K)"
                        list={auditQuestionData}
                        patientName={patientName}
                    />}
                    {selectedSession===1 && e.moduleId===2 && rtcqQuestionData.length>0 && <AccordianItem
                        title="변화준비척도(RTCQ)"
                        list={rtcqQuestionData}
                        patientName={patientName}
                    />}
                </div>
            ))}            
        </div>
    );
}

export default AlcoholEducation;